function langaugeSelector(e) {
  const dataLanguage = e.dataset.language;
  const dataCountry = e.dataset.country;
  const dataDomain = e.dataset.domain;
  const countrySelector = document.querySelector('input[name="country_code"]');
  const languageSelector = document.querySelector('input[name="locale_code"]');
  countrySelector.value = dataCountry;
  languageSelector.value = dataLanguage;

  const currentDomain = window.location.origin;
  if (dataDomain === currentDomain) {
    localStorage.setItem("current_jp_country", dataCountry);
    localStorage.setItem("current_jp_language", dataLanguage);
  }

  document.getElementById("localization_form").submit();
}

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".close-lang, .language-overlay").forEach(function (element) {
    element.addEventListener("click", function () {
      document.querySelector(".modal").classList.remove("modal-active");
    });
  });

  document.querySelectorAll(".langs").forEach(function (element) {
    element.addEventListener("click", function () {
      document.querySelector(".modal").classList.add("modal-active");
    });
  });

  function checkLocalStorage() {
    const current_jp_country = localStorage.getItem("current_jp_country");
    const current_jp_language = localStorage.getItem("current_jp_language");
    const jp_country_input = document.querySelector('input[name="country_code"]');
    const jp_language_input = document.querySelector('input[name="locale_code"]');

    if(!Shopify.designMode) { //to not save or redirect when on Shopify customizer
      if (current_jp_country && current_jp_language && current_jp_country != "EN") {
        if (jp_country_input.value != current_jp_country || jp_language_input.value != current_jp_language) {
          jp_country_input.value = current_jp_country;
          jp_language_input.value = current_jp_language;
          document.getElementById("localization_form").submit();
        }
      } else {
        localStorage.setItem("current_jp_country", jp_country_input.value);
        localStorage.setItem("current_jp_language", jp_language_input.value);
      }
    }
  }
  checkLocalStorage();
});
